import React from 'react';
import { Router } from '@reach/router';
import Dashboard from '../views/Dashboard';
import UsersPage from '../views/UsersPage';
import Logout from '../views/Logout';
import DataPage from '../views/DataPage';
import StatisticsPage from '../views/StatisticsPage';
import AdminQuality from '../views/AdminQuality';
import AdminUserDetail from '../views/AdminUserDetail';
import AdminLabs from '../views/AdminLabs';

const ProtectedRoutes = () => (
    <Router>
        <Dashboard path='/dashboard' />
        <UsersPage path='/users' />
        <DataPage path='/datalist' />
        <StatisticsPage path='/statistics' />
        <AdminQuality path='/admin/quality' />
        <AdminUserDetail path='/admin/quality/user/:email' />
        <AdminLabs path='/admin/labs' />
        <Logout path='/logout' />
    </Router>
);

export default ProtectedRoutes;